module.exports = __webpack_public_path__ + "assets/img/e237-ly.svg";